const CookieOptions = {
  TEN_MINUTES: {
    expires: new Date(new Date().getTime() + 10 * 60 * 1000),
    path: '/',
  },
};

export default CookieOptions;
